<div class="oops">Oops!</div>
<div class="message">We can't seem to find what you are looking for.</div>